let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hvZx7")).then(() => parcelRequire('f6tst'));